<emm-menu-layout>
    <emm-menu-filters #filters layout-left [filtersWidth]="'238px'" (deleteConsumer)="onDeleteConsumer($event)"></emm-menu-filters>
    <emm-menu-tree #tree layout-center [centerPaneWidth]="'calc((100% - 250px) * 0.5);'"
                   (selectItem)="onSelectItem($event)"
                   [submenuRenamed]="submenuRenamed"
    ></emm-menu-tree>
    <emm-menu-attributes
        #form layout-right [rightPaneWidth]="'calc((100% - 250px) * 0.6);'" (submenuRenamed)="onSubmenuRenamed($event)"
    ></emm-menu-attributes>
</emm-menu-layout>
